import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export default function SectionHeading({ eyebrow, title, copy, center = false }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease }}
      className={center ? "mx-auto max-w-2xl text-center" : "max-w-3xl"}
    >
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-terra">{eyebrow}</p>
      <h2 className="mt-4 font-serif text-3xl font-medium tracking-tight text-slate-100 sm:text-4xl lg:text-5xl">
        {title}
      </h2>
      {copy && <p className="mt-5 text-base leading-relaxed text-slate-400 md:text-lg">{copy}</p>}
    </motion.div>
  );
}
